<template>
    <div>
        <div class="tw:flex tw:justify-between tw:items-center tw:mb-4">
            <h2 class="tw:text-lg tw:font-semibold tw:text-gray-900">Valoración</h2>
            <Button
                icon="fas fa-pen"
                class="tw:text-xs tw:sm:text-sm"
                @click="openForm"
            >
                {{ valoracion ? 'Editar' : 'Crear' }}
            </Button>
        </div>

        <div v-if="valoracion" class="tw:bg-gray-50 tw:rounded-xl tw:p-5">
            <BaseBarChart :items="chartItems" />
        </div>

        <ModalBase
            name="form-valoracion"
            title="EDITAR VALORACIÓN"
            @close="closeForm"
        >
            <FormValoracion
                :base_id="base_id"
                :valoracion="valoracion"
                @edit="onEdit"
                @cancel="closeForm"
            />
        </ModalBase>
    </div>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import BaseBarChart from '@/modules/admin/ui/BaseBarChart.vue'
    import FormValoracion from '@/modules/admin/bases/forms/FormValoracion.vue'

    const props = defineProps({
        valoracion: {
            type: Object,
            default: null
        },
        base_id: {
            type: [String, Number],
            required: true
        }
    })

    const emit = defineEmits(['getBase'])

    const instance = getCurrentInstance()

    const chartItems = computed(() => {
        if (!props.valoracion) return []
        return [
            { label: 'Val. Técnica', value: props.valoracion.tecnica, max: 10 },
            { label: 'Val. Táctica', value: props.valoracion.tactica, max: 10 },
            { label: 'Cap. Física', value: props.valoracion.fisica, max: 10 },
            { label: 'Psicológica', value: props.valoracion.psicologica, max: 10 },
            { label: 'Personalidad', value: props.valoracion.personalidad, max: 10 },
            { label: 'Media', value: props.valoracion.media, max: 10 },
        ]
    })

    const openForm = () => {
        instance.proxy.$modal.show('form-valoracion')
    }

    const closeForm = () => {
        instance.proxy.$modal.hide('form-valoracion')
    }

    const onEdit = () => {
        closeForm()
        emit('getBase')
    }
</script>
